<template>
  <div v-if="$store.getters.retrieveAdmin">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12">
        <v-banner icon="event">
          {{ orderDateLabel }}
          <template v-slot:actions>
            <v-btn
              v-if="$store.getters.retrieveAdmin.account_type != 'C1'"
              outlined
              color="blue darken-2"
              :to="{ name: 'CustomerSearch' }"
            >
              <v-icon left>undo</v-icon>
              Change Customer
            </v-btn>

            <v-btn
              v-if="$store.getters.retrieveHasMultipleTrollys"
              outlined
              color="blue darken-2"
              :to="{ name: 'OrdersBasketSelection' }"
            >
              <v-icon left>shopping_cart</v-icon>Change Basket
            </v-btn>
          </template>
        </v-banner>
      </v-col>

      <v-col cols="12" lg="8" sm="12">
        <v-form ref="createOrderForm" v-model="valid" @submit.prevent>
          <CncSwitch class="mb-4"></CncSwitch>
          <CncAddress class="mb-4"></CncAddress>
          <DeliveryAddress
            class="mb-4"
            :showSelectAddress="true"
            :outlined="true"
          />
          <OrderDate
            v-model="orderDate"
            :order="this.$store.getters.retrieveCurrentTrolly"
          ></OrderDate>
          <OrderReference
            v-model="custRef"
            :order="this.$store.getters.retrieveCurrentTrolly"
          ></OrderReference>
          <v-select
            :items="$store.getters['retrieveFormatedDists']"
            v-model="distributorSelected"
            v-if="isDistFilterEnabled"
            label="Choose Distributor"
            outlined
          >
          </v-select>
          <!-- <v-radio-group
            v-model="distributorSelected"
            v-if="isDistFilterEnabled"
            row
          >
            <v-radio :value="0" color="blue darken-2">
              <template v-slot:label>
                <div>All</div>
              </template>
            </v-radio>

            <v-radio
              v-for="(filter, index) in $store.getters[
                'retrieveDistributorsAvailable'
              ]"
              :key="index"
              :value="parseInt(filter.number)"
              color="blue darken-2"
            >
              <template v-slot:label>
                <div>{{ filter.name }}</div>
              </template>
            </v-radio>
          </v-radio-group> -->
          <v-btn
            :loading="loading"
            block
            color="primary"
            x-large
            type="submit"
            @click="submit"
            :disabled="!valid"
            >Confirm Date</v-btn
          >
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import CncSwitch from "@/components/order/CncSwitch.vue";
import CncAddress from "@/components/order/CncAddress.vue";

import OrderDate from "@/components/order/Date.vue";
import OrderReference from "@/components/order/Reference.vue";

import DeliveryAddress from "@/components/deliveryAddresses/SelectedAddress.vue";

export default {
  components: {
    CncSwitch,
    CncAddress,
    OrderDate,
    OrderReference,
    DeliveryAddress,
  },
  data() {
    return {
      valid: false,
      loading: false,
      orderDate: null,
      custRef: null,
    };
  },

  async activated() {
    await this.getCustomer();
    await this.getDistributors();

    if (!this.$store.getters.retrieveAnon) {
      await this.getSelectedDeliveryAddress();
    }
  },

  computed: {
    ...mapGetters(["isDistFilterEnabled"]),
    orderDateLabel() {
      let label = "Delivery Details";

      console.log(this.$store.getters.retrieveCurrentTrolly);
      console.log(0);
      if (this.$store.getters.retrieveCurrentTrolly) {
        console.log(1);
        if (this.$store.getters.retrieveIsCncCustomer) {
          console.log(2);
          label = "Update Collection Details";
        } else {
          console.log(3);
          label = "Update Delivery Details";
        }
      } else {
        console.log(4);
        if (this.$store.getters.retrieveIsCncCustomer) {
          console.log(5);
          label = "Select Collection Details";
        } else {
          console.log(6);
          label = "Select Delivery Details";
        }
      }

      return label;
    },

    distributorSelected: {
      get() {
        return this.$store.state.customer.selectedDistributor;
      },
      set(val) {
        this.$store.commit("setSelectedDistributor", val);
      },
    },
  },

  methods: {
    ...mapActions([
      "getCustomer",
      "createNewTrolly",
      "setSelectedTrolly",
      "getTrollys",
      "updateTrollyOrderDate",
      "updateTrollyCustRef",
      "getDistributors",
      "getSelectedDeliveryAddress",
    ]),

    getInitialDate() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return this.$store.getters.retrieveCurrentTrolly.order_date;
      } else {
        return null;
      }
    },

    getInitialRef() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return this.$store.getters.retrieveCurrentTrolly.cust_ref;
      } else {
        return "";
      }
    },

    async submit() {
      this.loading = true;

      if (this.$refs.createOrderForm.validate()) {
        //Check if we have an existing trolly
        if (!this.$store.getters.retrieveCurrentTrolly) {
          // We Do NOT so create one now
          let orderObject = {
            orderDate: this.orderDate,
            custRef: this.custRef,
          };

          console.log(orderObject);

          let trollyCreated = await this.createNewTrolly(orderObject);

          if (trollyCreated != false) {
            console.log("-- Created Trolly");
            this.setSelectedTrolly(parseInt(trollyCreated.trollyId));

            //Get our trollies next
            await this.getTrollys()
              .then((response) => {
                console.log("-- Got Trollys");
                console.log(response);
                this.$router.push({ name: "OrdersSearch" });
              })
              .catch((er) => {
                console.log(er);
              });
          } else {
            console.log("-- Error Creating Trolly");
          }
        } else {
          //We Do
          console.log("-- Existing Trolly");

          //Check if we've changed anything
          if (
            this.$store.getters.retrieveCurrentTrolly.order_date !=
              this.orderDate ||
            this.$store.getters.retrieveCurrentTrolly.cust_ref != this.custRef
          ) {
            // console.log("-- Date Comparison");
            // console.log("  -- retrieveCurrentTrolly Date");
            // console.log(this.$store.getters.retrieveCurrentTrolly.order_date);
            // console.log("  -- this.orderDate");
            // console.log(this.orderDate);

            // console.log("-- Reference Comparison");
            // console.log("  -- retrieveCurrentTrolly Ref");
            // console.log(this.$store.getters.retrieveCurrentTrolly.cust_ref);
            // console.log("  -- this.custRef");
            // console.log(this.custRef);

            //We have so update our trolly here
            console.log("-- Date or Reference Amended");
            let trollyDateUpdate = true;
            let trollyRefUpdate = true;

            let orderObject = {
              orderDate: this.orderDate,
              custRef: this.custRef,
            };

            if (
              this.$store.getters.retrieveCurrentTrolly.order_date !=
              this.orderDate
            ) {
              //Update our order date here
              trollyDateUpdate = await this.updateTrollyOrderDate(orderObject);
            }

            console.log("-- Comparing Trolly Ref to ours");
            console.log(this.$store.getters.retrieveCurrentTrolly.cust_ref);
            console.log(this.custRef);

            if (
              this.$store.getters.retrieveCurrentTrolly.cust_ref != this.custRef
            ) {
              //Update our cust refrerence
              trollyRefUpdate = await this.updateTrollyCustRef(orderObject);
            }

            console.log("-- Checking Data Success");
            console.log(trollyDateUpdate);
            console.log(trollyRefUpdate);

            if (trollyDateUpdate == true && trollyRefUpdate == true) {
              console.log("-- Amended Trolly");
              //Get our trollies next
              await this.getTrollys()
                .then((response) => {
                  console.log("-- Got Trollys");
                  console.log(response);
                  this.$router.push({ name: "OrdersSearch" });
                })
                .catch((er) => {
                  console.log(er);
                });
            } else {
              console.log("-- Error Creating Trolly");
            }
          } else {
            //We have NOT so continue
            console.log("-- Nothing Amended");
            this.$router.push({ name: "OrdersSearch" });
          }
        }
      }

      this.loading = false;
    },
  },
};
</script>